import React from 'react'

export type GridIconButtonVariant = 'primary' | 'secondary' | 'warning' | 'danger' | 'ghost'

const variantClass: Record<GridIconButtonVariant, string> = {
	primary: 'btn btn-sm btn-primary',
	secondary: 'btn btn-sm btn-outline-secondary',
	warning: 'btn btn-sm btn-outline-warning',
	danger: 'btn btn-sm btn-outline-danger',
	ghost: 'btn btn-sm btn-ghost',
}

export type GridIconButtonProps = {
	icon: string
	title: string
	onClick: () => void
	variant?: GridIconButtonVariant
	disabled?: boolean
	className?: string
}

export const GridIconButton: React.FC<GridIconButtonProps> = ({
	icon,
	title,
	onClick,
	variant = 'secondary',
	disabled,
	className = '',
}) => (
	<button
		type="button"
		className={`${variantClass[variant]} px-2 ${className}`.trim()}
		onClick={onClick}
		title={title}
		aria-label={title}
		disabled={disabled}
	>
		<i className={icon} aria-hidden />
	</button>
)

export const GridIconActions: React.FC<{ children: React.ReactNode; className?: string }> = ({
	children,
	className = '',
}) => <div className={`grid-row-actions ${className}`.trim()}>{children}</div>
